module.exports = __webpack_public_path__ + "media/images/kid0-cf29debcb6655ac4964ad4087911a253.jpg";